import { render } from "./Punishment.vue?vue&type=template&id=c47bdca0"
import script from "./Punishment.vue?vue&type=script&lang=js"
export * from "./Punishment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__